// Trailing arrow on the sign-in call to action. Decorative — always paired with
// the visible "Sign in" label, so it is aria-hidden. Size via CSS font-size
// (renders at 1em); color via currentColor.
export function ArrowRightIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
